import axios from "../../config/axiosConfig";
import { GET_MODULES, GET_MODULES_STRUCTURE, MODULE_REQUEST, MODULE_REQUEST_FAILURE } from "../types";

export const getModules = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      const { auth } = getState();
      return axios.get("/module/getAll", { params: { userId: auth?.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_MODULES, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getUserModules = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      const { auth } = getState();
      return axios.get("/module/getUserModules", { params: { userId: auth?.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_MODULES, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getModuleStructure = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      const { auth } = getState();
      return axios.get("/module/getModuleStructure", { params: { userId: auth?.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_MODULES_STRUCTURE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getUserModuleStructure = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      const { auth } = getState();
      return axios.get("/module/getUserModuleStructure", { params: { userId: auth?.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: GET_MODULES_STRUCTURE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createModule = (module) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      const { auth } = getState();
      return axios.post("/module/add", module, { params: { userId: auth?.superUser?.id } }).then((response) => {
        if (response.data) {
        // dispatch({ type: CREATE_MODULE, payload: response.data });
        dispatch(getModules());
      } else {
        dispatch({
          type: MODULE_REQUEST_FAILURE,
          error: "Module create failed.",
        });
      }
      return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateModule = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      const { auth } = getState();
      return axios.put("/module/update", { id, data }, { params: { userId: auth?.superUser?.id } }).then((response) => {
        if (response.data) {
          // dispatch({
          //   type: UPDATE_MODULE,
          //   payload: { id, data: response.data },
          // });
          dispatch(getModules());
        } else {
          dispatch({
            type: MODULE_REQUEST_FAILURE,
            error: "Module update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteModule = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MODULE_REQUEST });
      return axios.delete(`/module/delete/${id}`).then((response) => {
        if (response.data) {
          // dispatch({ type: DELETE_MODULE, id: id });
          dispatch(getModules());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: MODULE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
